import { z } from "zod";

/**
 * Selection scopes for TeamMemberSelectV2 and contract list filters.
 * Tab keys: consultants, independents, managees, inactives.
 * Managees-only granular scopes: managees_independents, managees_consultants.
 */
export const teamMemberTabScopeSchema = z.enum([
  "consultants",
  "independents",
  "managees",
  "managees_independents",
  "managees_consultants",
  "inactives",
]);
export type TeamMemberTabScope = z.infer<typeof teamMemberTabScopeSchema>;

export const teamMemberSelectionEntrySchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("id"), value: z.guid() }),
  z.object({ type: z.literal("filter"), value: teamMemberTabScopeSchema }),
]);

export type TeamMemberSelectionEntry = z.infer<typeof teamMemberSelectionEntrySchema>;
